import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule, Optional, SkipSelf } from '@angular/core';
import { throwIfAlreadyLoaded } from './module-import.guard';

const GUARDS: any[] = []

@NgModule({
    imports: [
        CommonModule,
    ],
    exports: [
    ],
    declarations: [],
})
export class GuardsModule {
    constructor(@Optional() @SkipSelf() parentModule: GuardsModule) {
        throwIfAlreadyLoaded(parentModule, 'GuardsModule');
    }
    static forRoot(): ModuleWithProviders<GuardsModule> {
        return {
            ngModule: GuardsModule,
            providers: [
                ...GUARDS
            ],
        };
    }
}

//export const guardsModule = GuardsModule.forRoot();